import { RouteConfig } from '@abaco/web-common/src/app';

const MODULE_BASE_PATH = "/counts-dashboard";

const routes: RouteConfig[] = [
    {
        name: "counts-home",
        path: `${MODULE_BASE_PATH}/home`,
        component: () => import("./components/CountsDashboardContainer.vue"),
        meta: {
            navbarItems: ["reference-area-nav-bar-item", "plot-selection-nav-bar-item", "campaign-select-nav-bar-item", "farm-select-nav-bar-item", "s-c-leader-select-nav-bar-item"]
        }
    },
];

export default routes;
